var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home d-flex flex-column"},[_vm._m(0),_c('LoginForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"width":"250","height":"250","alt":"Lyt-Soft Logo"}})])
}]

export { render, staticRenderFns }